/**
 * Marketing site: always the marketing navbar. (In the original monorepo this
 * switched between marketing/app navbars by subdomain; the separated marketing
 * build only ever renders the marketing nav — the app lives on its own subdomain.)
 */
import { MarketingNavbar } from './MarketingNavbar';

export const ContextAwareNavbar = () => {
  return <MarketingNavbar />;
};
